import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=690478e9&"
import script from "./TagSelector.vue?vue&type=script&lang=ts&"
export * from "./TagSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports